/*@ngInject*/
const ProposalRepository = function (baseRepository, proposalSendType,currentSubmissionModel) {

    angular.extend(this, baseRepository);

    this.sendProposal = function (proposalId) {
        var url = '/rest/Proposal/' + proposalId + '/send?proposalSendType=' + proposalSendType.SEND_PROPOSAL;

        return this.post(url);
    };

    this.findById = function (proposalId) {
        var url = '/rest/Proposal/' + proposalId
        return this.get(url);
    };

    this.getSections = function (proposalId) {
        var url = '/rest/Proposal/' + proposalId + '/ProposalSections';
        return this.get(url);
    };

    this.stitchSections = function (proposalId, sectionType) {
        var url = '/rest/Proposal/' + proposalId + '/previewStichedDocuments',
            config = {
                params: {
                    sectionType: sectionType
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };

    this.updateSection = function (sectionId, stitchable) {
        var url = '/rest/ProposalSection/' + sectionId,
            config = {
                params: {
                    stitchable: stitchable
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };

    this.moveSection = function (sectionId, proposalOrdinalNumber) {
        var url = '/rest/ProposalSection/' + sectionId + '/moveSection',
            config = {
                params: {
                    proposalOrdinalNumber: proposalOrdinalNumber
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };

    this.uploadSectionFromFile = function (proposalId, data, file) {
        var url = '/rest/Proposal/'+proposalId+'/uploadSectionFromFile',
            formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                // When you assign undefined, the content type defaults to multipart/form-data
                headers: {
                    'Content-Type': undefined
                },
                params:{
                    displayLabel: data.description,
                    filename:data.name,
                    length:data.fileExpectedSize
                }
            };

        formData.append('file', file);

        return this.post(url, formData, config);
    };

};


angular.module('gw-um-submission')
    .service('proposalRepository', ProposalRepository);
